import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { StatsmanService } from "../../models/statsman.service";
import { sum } from "../../utils/sum";

@Component({
  selector: "ab-project-cards",
  templateUrl: "./cards.component.html",
})
export class ProjectCardsComponent implements OnChanges {
  @Input() public diffStatAggregations: any;
  @Input() public dur: string;
  @Input() public lastN: number;
  @Input() public project: any;

  public acceptedCount: number;
  public acceptedCountList: number[];
  public deployCount: number;
  public deployCountList: number[];
  public newGroupCount: number;
  public newGroupCountList: number[];

  constructor(private statsmanService: StatsmanService) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.dur == null && changes.lastN == null) {
      return;
    }
    if (this.dur == null || this.lastN == null) {
      return;
    }
    this.calcStats(this.dur, this.lastN);
  }

  private calcStats(dur: string, lastN: number) {
    const deployKey = `projects.${this.project.id}.deploys`;
    const newGroupsKey = `projects.${this.project.id}.groups.created`;
    const acceptedKey = `projects.${this.project.id}.notices`;
    const params = {
      projectId: this.project.id,
      name: [deployKey, newGroupsKey, acceptedKey],
      type: "counter",
      dur,
      last_n: lastN,
    };
    this.statsmanService.query(params).subscribe((data: any) => {
      this.deployCount = sum(data[deployKey].count);
      this.newGroupCount = sum(data[newGroupsKey].count);
      this.acceptedCount = sum(data[acceptedKey].count);

      this.deployCountList = data[deployKey].count;
      this.acceptedCountList = data[acceptedKey].count;
      this.newGroupCountList = data[newGroupsKey].count;
    });
  }
}
